import React, { useState, useEffect } from 'react';
import axios from '../util/Api'
import "../styles/register.scss"
import { getLogo } from "../util/getLogo";
import 'antd/dist/antd.css'
import { connect, useSelector } from "react-redux";

import { Row, Col, Card, Input, Select, InputNumber, Button, message } from 'antd'
import { Link } from 'react-router-dom';

import { MailOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { addRegister } from "../appRedux/actions/Register";
import InfoView from "../components/InfoView";

import { SearchOutlined } from '@ant-design/icons';

const Register = (props) => {
    const logo = getLogo()
    const [showRecaptcha, setShowRecaptcha] = useState(false)

    const [typeDocument, setTypeDocument] = useState('')
    const [clientDocument, setClientDocument] = useState('')
    const [clientName, setClientName] = useState('')
    const [clientLastNameFather, setClientLastNameFather] = useState('')
    const [clientLastNameMother, setClientLastNameMother] = useState('')
    const [clientEmail, setClientEmail] = useState('')
    const [clientPassword, setClientPassword] = useState('')
    const [clientRepeatPassword, setClientRepeatPassword] = useState('')

    const { Option } = Select;

    // old
    const [ruc, setRuc] = useState('')
    const [businessName, setBusinessName] = useState('')
    const [address, setAddress] = useState('')
    const [fullName, setFullName] = useState('')
    const [email, setEmail] = useState('')
    const [campus, setCampus] = useState('')
    const [phone, setPhone] = useState('')
    let [show, setShow] = useState('1')
    let [showruc, setShowruc] = useState(false)
    const [rucLoading, setRucloading] = useState(false)

    const register_loading = useSelector(store => store.register.loading)
    const registerStatusActions = useSelector(store => store.register.registerStatusActions)
    const register_message = useSelector(store => store.register.register_message)
    const [tokenRecaptcha, setTokenRecaptcha] = useState('')

    const userName = useSelector(store => store.register.userName)
    let RegexEmail = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,6})+$/;
    let RegexNumber = /^([0-9])*$/;

    function handleChangeTypeDocument(event) {
        setClientDocument('')
        setTypeDocument(event)
    }

    function handleChangeClientDocument(event) {
        setClientDocument(event.target.value)
    }

    function handleChangeClientName(event) {
        setClientName(event.target.value)
    }

    function handleChangeClientLastNameFather(event) {
        setClientLastNameFather(event.target.value)
    }

    function handleChangeClientLastNameMother(event) {
        setClientLastNameMother(event.target.value)
    }

    function handleChangeClientEmail(event) {
        setClientEmail(event.target.value)
    }

    function handleChangeClientPassword(event) {
        setClientPassword(event.target.value)
    }

    function handleChangeClientRepeatPassword(event) {
        setClientRepeatPassword(event.target.value)
    }


    function handleOnSave() {

        if (typeDocument == '') {
            message.error('Ingrese el tipo de documento')
            return false;
        }

        if (clientDocument == '') {
            message.error('Ingrese número de documento')
            return false;
        }

        if (typeDocument == "DNI") {
            if (clientDocument.length != 8) {
                message.error('El número de documento debe tener 8 caracteres')
                return false;
            }

            if (!RegexNumber.test(clientDocument)) {
                message.error("El número de documento solo debe contener números.");
                return false
            }
        } else {
            if (clientDocument.length < 5 && clientDocument.length > 12) {
                message.error('El número de documento debe tener entre 5 y 12 caracteres')
                return false;
            }
        }
        

        if (clientName == '') {
            message.error('Ingrese el nombre')
            return false;
        }

        if (clientLastNameFather == '') {
            message.error('Ingrese apellido paterno')
            return false;
        }

        if (clientLastNameMother == '') {
            message.error('Ingrese apellido materno')
            return false;
        }

        if (clientEmail == '') {
            message.error('Ingrese un correo')
            return false;
        }

        if (!RegexEmail.test(clientEmail)) {
            message.error("La dirección de email es incorrecta.");
            return false
        }
        
        if (clientPassword == '') {
            message.error('Ingrese contraseña')
            return false;
        }

        if (clientRepeatPassword == '') {
            message.error('Repita contraseña')
            return false;
        }
        
        if (clientPassword !== clientRepeatPassword) {
            message.error('Las contraseñas no coinciden')

            return false;
        }

        // old

        // if (showRecaptcha) {
        //     handleLoaded()
        // }

        let register = {
            client_natural_type_document: typeDocument,
            client_natural_document: clientDocument,
            client_natural_name: clientName,
            client_natural_lastname_father: clientLastNameFather,
            client_natural_lastname_mother: clientLastNameMother,
            client_natural_email: clientEmail,
            client_natural_password: clientPassword
            // token: tokenRecaptcha
        }

        props.addRegister(register);
    }

    // old
    function handleOnSearchRuc() {
        if (ruc == '') {
            message.error('Ingrese un RUC')
            return false;
        }
        let register = {
            ruc: ruc
        }

        let config = {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }
        setRucloading(true)
        axios.post('/external/clients/searchruc',
            register,
            config
        ).then(({ data, status }) => {
            if (data) {
                setAddress(data.data.address)
                setBusinessName(data.data.businessName)
                setShowruc(true)
                setRucloading(false)
            }
        }).catch(function (error) {
            setShowruc(false)
            setAddress('')
            setBusinessName('')
            setRucloading(false)
            if (error.response) {
                message.error(error.response.data.message)

            } else if (error.request) {
                message.error('Error de red')
            } else {
                message.error('Error de red')
                // anything else
            }

        });
    }

    function redirectLogin() {
        var obj = document.getElementById('script')
        if (obj) {
            obj.remove();

        }

        return window.location = '/login';

    }

    useEffect(() => {

        if (registerStatusActions == 0) {
            setShow('1')

        } else
            if (registerStatusActions == 201) {
                setShow('2')

            }


    }, [registerStatusActions]);

    const handleLoaded = _ => {
        window.grecaptcha.ready(_ => {
            window.grecaptcha
                .execute("6Led0P0UAAAAAEyyrKlkd3zrZT3GnimnbOznbGCY", { action: "homepage" })
                .then(token => {
                    console.log(token)
                    setTokenRecaptcha(token)
                })
        })
    }

    useEffect(() => {
        if (showRecaptcha) {
            const script = document.createElement("script")
            script.id = 'script'
            script.src = "https://www.google.com/recaptcha/api.js?render=6Led0P0UAAAAAEyyrKlkd3zrZT3GnimnbOznbGCY"
            script.addEventListener("load", handleLoaded)
            document.body.appendChild(script)
        }
    }, [showRecaptcha])

    useEffect(() => {
        recaptcha()


    }, [])
    const recaptcha = () => {
        axios.get('external/recaptcha',
            {
                headers: {
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        ).then(({ data }) => {

            setShowRecaptcha(data.message)


        }).catch(function (error) {
            setShowRecaptcha(false)
        });
    }

    return (
        <div class='body ' >
            <Row style={{ justifyContent: 'center',padding:'2rem' }}>
                <img width="200" src={logo} />
            </Row>
            {show == '1' ?
                (
                    <Row style={{ justifyContent: 'center' }} >
                        <Card title='' className='card' >
                            <div class="title-primary" style={{ justifyContent: 'center' }} >Generación de usuario  </div>
                            <br></br>
                            <div class="title-secondary" >Datos del contacto  </div>

                            <Row gutter={16}>

                                <Col className="gutter-row" xs={24} lg={8} >
                                    <Select
                                        showSearch
                                        style={{ width: 200 }}
                                        placeholder="Tipo de documento"
                                        optionFilterProp="children"
                                        onChange={handleChangeTypeDocument}
                                        filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        
                                        <Option value="DNI">DNI</Option>
                                        <Option value="CARNET">CARNET DE EXTRANJERÍA</Option>
                                        <Option value="PASAPORTE">PASAPORTE</Option>
                                    </Select>
                                </Col>
                                <Col className="gutter-row" xs={24} lg={16} >
                                    <Input className="password_input" maxLength={typeDocument === "DNI" ? 8 : 12} minLength={typeDocument === "DNI" ? 8 : 5} value={clientDocument} onChange={handleChangeClientDocument} placeholder='Número de documento' />
                                </Col>
                                <Col className="gutter-row" xs={24} lg={24} >
                                    <Input className="password_input" maxLength={250} value={clientName} onChange={handleChangeClientName} placeholder='Nombre' />
                                </Col>
                                <Col className="gutter-row" xs={24} lg={12} >
                                    <Input className="password_input" maxLength={250} value={clientLastNameFather} onChange={handleChangeClientLastNameFather} placeholder='Apellido paterno' />
                                </Col>
                                <Col className="gutter-row" xs={24} lg={12} >
                                    <Input className="password_input" maxLength={250} value={clientLastNameMother} onChange={handleChangeClientLastNameMother} placeholder='Apellido materno' />
                                </Col>
                                <Col className="gutter-row" xs={24} lg={24} >
                                    <Input className="password_input" maxLength={250} value={clientEmail} onChange={handleChangeClientEmail} placeholder='Correo electronico' />
                                </Col>
                                <Col className="gutter-row" xs={24} lg={24} >
                                    <Input type="password" className="password_input" maxLength={250} value={clientPassword} onChange={handleChangeClientPassword} placeholder='Ingrese Contraseña' />
                                </Col>
                                <Col className="gutter-row" xs={24} lg={24} >
                                    <Input type="password" className="password_input" maxLength={250} value={clientRepeatPassword} onChange={handleChangeClientRepeatPassword} placeholder='Repita Contraseña' />
                                </Col>
                            </Row>
                            <br></br>
                            <Row style={{ justifyContent: 'center' }}>


                                <Button onClick={handleOnSave} loading={register_loading} className='btn-orange'>Registrarse</Button>



                            </Row>
                            <Row style={{ justifyContent: 'center' }}>
                                <p style={{ justifyContent: 'center' }}>¿Ya tienes tu cuenta?&nbsp; </p> <a onClick={redirectLogin}> Inicia sesión </a>
                            </Row>

                        </Card>
                    </Row>
                ) : (

                    <Row >
                        <Col style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }} xs={18}>
                            <Card className='card'>

                                <div className="advisorCard" style={{ textAlign: "center" }}>
                                    <CheckCircleOutlined
                                        style={{
                                            fontSize: "2.5rem",
                                            color: "#0099cc",
                                            marginTop: ".5rem",
                                            marginBottom: ".5rem",
                                        }}
                                    />
                                    <p
                                        style={{
                                            fontSize: "1.6rem",
                                            fontWeight: "bolder",
                                            color: "#4a4a4a",
                                            marginBottom: "1rem",
                                        }}
                                    >
                                        ¡Registro exitoso!
                    </p>
                                    <br></br>
                                    <div class="title-secondary" style={{ textAlign: 'center' }} >Se han generado tus credencialesde acceso, su usuario es:</div>
                                    <br></br>
                                    <Row  >
                                        <Col xs={24} lg={24} >
                                            <Input style={{ borderRadius: '20px', margin: '5px', textAlign: 'center' }} size="" value={clientDocument} disabled />

                                        </Col>
                                        <br></br>

                                    </Row>

                                    <p
                                        style={{

                                            fontSize: "0.9rem",
                                            marginTop: "1rem",
                                            marginBottom: "1rem",
                                        }}
                                    >
                                        <MailOutlined />  Se te ha enviado un correo con un enlace de activación de tu cuenta, luego de ello ya podrá <Link to='/' >iniciar sesión</Link>.
                    </p>

                                </div>
                            </Card>
                        </Col>
                    </Row>


                )
            }

            <InfoView />
        </div >
    );

}



export default connect(null, { addRegister })(Register);

